var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPi = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#pi_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.981 1.457a1.714 1.714 0 0 1-1.44 1.953l-3.684.558v16.497c.004.02.01.038.02.055l.004.002.01.005c.099.035.204.05.309.044.387 0 .73-.137 1.03-.355.319-.228.514-.492.566-.582a1.714 1.714 0 1 1 2.98 1.697C23.262 22.226 21.695 24 19.2 24c-1.293 0-2.311-.497-2.971-1.303a3.56 3.56 0 0 1-.8-2.217V4.486l-5.149.782c-.018 2.143-.1 5.047-.46 7.966-.441 3.573-1.333 7.54-3.323 10.102a1.713 1.713 0 1 1-2.709-2.101c1.372-1.768 2.195-4.903 2.628-8.42.309-2.505.402-5.019.429-7.026l-1.215.183c-1.286.285-2.07 1.463-2.258 2.178a1.714 1.714 0 1 1-3.316-.871c.412-1.564 1.96-4.063 4.92-4.672l.09-.017L22.028.02a1.714 1.714 0 0 1 1.953 1.438Z",
  fill: "#F9F9F9"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "pi_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
export default SvgPi;